if (window.matchMedia('(min-width: 1024px)').matches) {
  const asideEl = document.querySelector('aside');

  asideEl?.addEventListener('scroll', () => {
    if (asideEl.scrollTop != 0) {
      asideEl.classList.add('scrolled');
    } else {
      asideEl.classList.remove('scrolled');
    }
  });
}